import React, { useState, useMemo } from 'react';
import { Box, CircularProgress, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, FormGroup, Grid, IconButton, Radio, Stack, } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
// icons
import CloseIcon from '@mui/icons-material/Close';
// utils and helpers
import { closeCustomModalDialog, setModalLoader } from '../../../redux/slices/modalSlice';
// custom components
import MDButton from 'components/MDButton';
import Search from "examples/Search";
import NoDataFound from "common/component/NoDataFound";
import { showToastMsg } from "components/distributionSetting/distributionManagement/addRegionKit";

export default function DriverList({ closeModal }) {
  const dispatch = useDispatch()
  const { loading } = useSelector(state => state.adminDrivers || {});
  const { modalData, isLoading = false } = useSelector(state => state.modal);
  const { onDriverSelect, index, selected, drivers, selectedDrivers } = modalData;

  const [searchTerm, setSearchTerm] = useState('');
  const [selectedDriver, setSelectedDriver] = useState(selected);

  const handleSave = async () => {
    try {
      onDriverSelect(selectedDriver, index)

      dispatch(closeCustomModalDialog());
    } catch (err) {
      dispatch(setModalLoader(false));
      showToastMsg(err, "error")
    };
  }

  const handleSelectDriver = (e) => {
    const { value } = e.target;
    setSelectedDriver(value)
  }

  const filteredDrivers = useMemo(() => {
    if (searchTerm) {
      return drivers
        ?.filter(driver => driver.fleetName && driver.fleetName?.toLowerCase().includes(searchTerm?.toLowerCase()))
        .sort((a, b) => a.fleetName.localeCompare(b.fleetName))
    }
    return drivers
      ?.filter(driver => driver.fleetName && (driver._id === selected || !selectedDrivers?.includes(driver._id)))
      .sort((a, b) => a.fleetName.localeCompare(b.fleetName))
  }, [drivers, selected, selectedDrivers, searchTerm])

  return (
    <div className="driver-list-modal">
      <Box>
        <DialogTitle id='draggable-dialog-title' display='flex' alignItems='center' justifyContent='space-between'>
          <span style={{ color: "#9A9AAF" }}>Drivers List</span>
          <IconButton onClick={closeModal} edge='end' size='small'>
            <CloseIcon fontSize='medium' />
          </IconButton>
        </DialogTitle>

        {/* Search filter */}
        <Stack direction='row' flexWrap='wrap' alignItems='stretch' gap={2} p={2} className="modal-search pt-0">
          <Search
            placeholder='Search'
            label=''
            value={searchTerm}
            onChange={event => {
              const { value } = event.target;
              setSearchTerm(value);
            }} />
        </Stack>
      </Box>
      <DialogContent>
        <DialogContentText>
          <Grid item xs={12}>
            <Box className="px-3">
              <FormGroup className="multi-checkbox-sec gap-3">
                {
                  loading
                    ? <Box className="my-4 text-center"> <CircularProgress size={32} /></Box>
                    : filteredDrivers?.length > 0
                      ? filteredDrivers
                        ?.slice()
                        ?.filter(driver => driver._id === selected || !selectedDrivers?.includes(driver._id))
                        ?.map(driver => (
                          <FormControlLabel
                            key={driver._id}
                            label={driver.fleetName}
                            control={<Radio className='p-0 mr-2' name="driverId" value={driver?._id} checked={selectedDriver === driver._id} onChange={handleSelectDriver} />}
                          />
                        ))
                      : <div className='table-no-data-found'><NoDataFound /></div>
                }
              </FormGroup>
            </Box>
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ justifyContent: "space-between" }}>
        <Stack justifyContent="space-between" direction={{ xs: "row", sm: "row" }} spacing={2} className="w-100">
          <MDButton
            onClick={handleSave}
            sx={{ minWidth: "160px" }}
            type="button"
            variant="contained"
            color="primary"
          >
            {isLoading ? <CircularProgress size={16} color='light' /> : ' Save'}
          </MDButton>
          <MDButton
            onClick={closeModal}
            sx={{ minWidth: "160px" }}
            type="button"
            variant="outlined"
            color="dark"
          >
            Cancel
          </MDButton>
        </Stack>
      </DialogActions>
    </div>
  );
}